module.exports = __webpack_public_path__ + "static/media/catapult-app_2screen.80a4126e.png";